export default __webpack_public_path__ + "media/images/patchwork-532cf510ff4611c3dc353778ff3dcc3c.png";